import ContractorInfo from './components/ContractorInfo';
import Heading from './components/Heading';
import { InfoLinkPropsType } from './components/InfoLink';
import { ContractorCardContent } from './mockData';

export type ContractorCardPropsType = {
  tradeAllyName: string;
  yearOfService: string;
  stars: number;
  reviews: ReviewType[];
  lastQualityInspection: string;
  phone: string;
  website: string;
  brands: string[];
  products: string[];
  services: string[];
  additionalInformation: string;
  sendContractorCardAnalytics?: (data: InfoLinkPropsType['linkType']) => void;
};

export type ReviewType = {
  stars: number;
  review: string;
  name: string;
};

const resolver = (content: ContractorCardContent) => {
  return {
    tradeAllyName: content.tradeAllyName,
    yearOfService: content.yearOfService,
    stars: content.stars,
    reviews: content.reviews,
    lastQualityInspection: content.lastQualityInspection,
    phone: content.phone,
    website: content.website,
    brands: content.brands,
    products: content.products,
    services: content.services,
    additionalInformation: content.additionalInformation,
  };
};

const Main = (props: ContractorCardPropsType) => {
  return (
    <div
      data-testid="contractor-card"
      className="grow max-w-[366px] md:w-[366px] min-h-[503px] border border-gray-light rounded-md p-16 bg-white m-18 sm:ml-18 sm:mr-11"
    >
      <Heading
        tradeAllyName={props.tradeAllyName}
        yearOfService={props.yearOfService}
        stars={props.stars}
        reviews={props.reviews}
        lastQualityInspection={props.lastQualityInspection}
      />
      <ContractorInfo
        phone={props.phone}
        website={props.website}
        brands={props.brands}
        products={props.products}
        services={props.services}
        additionalInformation={props.additionalInformation}
        sendContractorCardAnalytics={props.sendContractorCardAnalytics}
      />
    </div>
  );
};

const ContractorCard = (props: any) => {
  const content = resolver(props);
  return <Main {...content} sendContractorCardAnalytics={props.sendContractorCardAnalytics} />;
};

export default ContractorCard;
